import { overlays } from '@ecosystem/newron-design-system';
import React from 'react';
import ReactDOM from 'react-dom';

export type ToastProps = Parameters<typeof overlays.Toast>[0];

const { Toast } = overlays;

function ClientToast(props: ToastProps): React.ReactPortal {
  return ReactDOM.createPortal(<Toast {...props} />, document.body);
}

export { ClientToast };
